module.exports = __webpack_public_path__ + "img/221122-bimistock-image-03@1x.aa1601f9.png";